'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.FlashService
 * @description
 * # flash.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('FlashService', FlashService);

FlashService.$inject = ['$rootScope', 'toastr'];

/**
 * @typedef {Object} FlashService
 * @property { (function(string)) } Success
 * @property { (function(string)) } Error
 * @property { (function(string)) } Warning
 * @property { (function()) } clear
 */

/**
 * @param { $rootScope } $rootScope
 * @param toastr
 * @return FlashService
 */
function FlashService($rootScope, toastr) {
  // AngularJS will instantiate a singleton by calling "new" on this function

  var service = {
    Success: Success,
    Error: Error,
    warning: warning,
    ErrorMessage: errorMessage,
    clear: clear
  };

  return service;

  function Success(message, keepAfterLocationChange) {
    toastr.success(message, 'Success');
  }

  function Error(message) {
    toastr.error(message, 'Error');
  }

  function warning(message) {
    toastr.warning(message, 'Warning');
  }

  function errorMessage(error) {
    toastr.error(error.message, error.title);
  }

  function clear() {
    toastr.clear();
  }
}
